import { useEffect, useState } from "react";
import { LOC_COLORS } from "./locCircle.constants";
import { TLocation } from "../../types/Locations";

const COLORS = ["#3CAE63", "#6D8196", "#FF7518", "#F1C338"];
const LocCircle = ({
  name,
  maxLength = 1,
  index = -1,
  greyScale = false,
  color = "",
}: {
  name: string;
  maxLength?: number;
  index?: number;
  greyScale?: boolean;
  color?: string;

}) => {
  const [circleInfo, setLocCircleInfo] = useState({
    size: "w-8 h-8",
    bold: "font-bold",
  });

  const getDisplayName = (name: string) => {
    if (name) {
      return name
        .split(" ")
        .map((name) => name[0])
        .slice(0, maxLength)
        .join("")
        .toUpperCase();
    }
    return "";
  };

  // useEffect(() => {
  //   if (color !== "") {
  //     setCircleInfo({
  //       size: "w-10 h-10",
  //       bold: "font-semibold",
  //     });
  //   }
  // }, [color]);

  return (
    <>
      <div
        className={`${Object.values(circleInfo).join(
          " "
        )} rounded-full flex items-center justify-center mr-2 text-xs`}
        style={{
          backgroundColor: color
            ? `${color}90`
            : `${COLORS[Math.floor(Math.random() * COLORS.length)]}90`,
          textDecorationColor: color         
          ? `${color}10`
          : `${COLORS[Math.floor(Math.random() * COLORS.length)]}10`,
          color
        }}
      >
        {getDisplayName(name)}
      </div>
    </>
  );
};

export default LocCircle;
